import { Button } from "@mui/material";
import React, { useState } from "react";
import {
  ModalButtonContainer,
  NegativeModalButton,
  PositiveModalButton,
} from "../../../../components/Button";
import { useModal } from "../../../../components/modal";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CustomTextField } from "../../../../components/TextFields";
import { Row } from "../../../../global/styledComponents";
import { SelectInput } from "../../../../components/inputs/SelectInput";
import { Level } from "../../../../types/level";
import { getLevelStr, toLevel } from "../../../../utils/level";
import FileUploader from "../../../../components/uploader/fileUploader";
import {
  useAddSnackPracticeMutation,
  useUpdateSnackPracticeMutation,
} from "../../../../app/services/practices.api";
import objToFromData from "../../../../utils/objToFromdata";
import { SnackPractice } from "../../../../types/practice";
import LoadingButton from "../../../../components/Button/LoadingButton";

const schema = yup.object().shape({
  title: yup.string().required("عنوان الزامی است."),
  desc: yup.string().required("توضیحات الزامی است."),
  level: yup.string().required("سطح تمرین الزامی است."),
});

export default function AddModal({
  snackId,
  practice,
}: {
  snackId: string;
  practice?: SnackPractice;
}) {
  const {
    setValue,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: practice
      ? {
          level: practice.level,
          desc: practice.desc,
          title: practice.title,
        }
      : { level: Level.BEGINNER },
  });
  const [file, setFile] = useState<File | null>(null);
  const [addPractice, addState] = useAddSnackPracticeMutation();
  const [editPractice, editState] = useUpdateSnackPracticeMutation();
  const { setShow } = useModal();
  return (
    <React.Fragment>
      <Row gap={"1rem"}>
        <CustomTextField
          variant="outlined"
          placeholder="عنوان را وارد کنید."
          label="عنوان"
          required
          onChange={(e) => setValue("title", e.target.value)}
          defaultValue={getValues("title")}
          error={!!errors.title}
          helperText={errors.title?.message}
        />
        <SelectInput
          label="سطح تمرین"
          error={!!errors.level}
          helperText={errors.level?.message}
          onChange={(e) => setValue("level", e?.value)}
          defaultValue={{
            label: getLevelStr(getValues("level") as Level) ?? undefined,
            value: toLevel(getValues("level")),
          }}
          options={[
            { label: "مبتدی", value: Level.BEGINNER },
            { label: "متوسط", value: Level.MEDUIM },
            { label: "پیشرفته", value: Level.ADVANCED },
          ]}
        />
      </Row>
      <CustomTextField
        variant="outlined"
        placeholder="توضیحات را وارد کنید."
        label="توضیحات"
        required
        onChange={(e) => setValue("desc", e.target.value)}
        defaultValue={getValues("desc")}
        error={!!errors.desc}
        helperText={errors.desc?.message}
        multiline
        minRows={2}
        maxRows={4}
      />
      <FileUploader title="فایل" onChange={(f) => setFile(f)} />
      <ModalButtonContainer>
        <Button
          style={NegativeModalButton}
          sx={{
            color: "divider",
            bgcolor: "primary.main",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            ":hover": {
              bgcolor: "divider",
              color: "primary.main",
            },
          }}
          onClick={() => setShow(false)}
        >
          انصراف
        </Button>
        <LoadingButton
          style={PositiveModalButton}
          sx={{
            ":hover": {
              bgcolor: "customColors.purple",
              color: "secondary.main",
            },
          }}
          isLoading={addState.isLoading || editState.isLoading}
          onClick={handleSubmit((data) => {
            const formData = objToFromData(data);
            if (file) formData.append("file", file);

            if (practice) {
              return editPractice({
                snackId,
                practiceId: practice._id,
                data: formData,
              })
                .unwrap()
                .then(() => {
                  setShow(false);
                })
                .catch((err) => {});
            }

            addPractice({ snackId, data: formData })
              .unwrap()
              .then(() => setShow(false))
              .catch((err) => {});
          })}
        >
          تایید
        </LoadingButton>
      </ModalButtonContainer>
    </React.Fragment>
  );
}
